import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState, useEffect, useRef } from 'react';
import "../../assets/css/modal.css";
import PropTypes from "prop-types";
import "../../assets/css/component.css";
import "./ChangePassword.css";
import { useForm } from "react-hook-form";
import PopUp from './Popup';
import { turnOffButton, turnOnButton } from "./buttonFunctions"
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { updatePassword } from '../../actions/userActions';
import { logoutUser } from '../../actions/authActions';
import { IoEyeOff, IoEye } from "react-icons/io5";
import { FiLock } from "react-icons/fi";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const ChangePassword = (props) => {
  const { register, reset } = useForm();
  const [password_current, setCurrPassword] = useState("");
  const [password_new, setNewPassword] = useState("");
  const [password_confirm, setCfmPassword] = useState("");
  const [popupTxt, setPopupTxt] = useState("");
  const [lshow, setLshow] = useState(false);

  // Eye toggles
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const buttonElement = useRef(null)
  if (localStorage.headers) {
    var login = JSON.parse(window.localStorage.getItem('headers'))
    var userid = login.data.user.user_id
    var usertoken = login.data.token;
  }

  useEffect(() => {
    turnOffButton(buttonElement.current);
    if (password_current === "" || password_new === "" || password_confirm === "") {
      turnOffButton(buttonElement.current);
    }

    else if (password_new === password_confirm) {
      turnOnButton(buttonElement.current);
    }
  }, [password_new, password_confirm, password_current])

  useEffect(() => {
    if (props.user.updatePassword) {
      const response = props.user.updatePassword.data
      if (response.message === "Current password does not match!") {
        setPopupTxt("Current password does not match!");
        setLshow(true);
      } else if (response.message === "Password successfully changed!") {
        setCurrPassword("");
        setNewPassword("");
        setCfmPassword("");
        // setPopupTxt("Password updated successfully!");
        reset();
        toast.success("Password updated successfully! Please log in again.");
        setTimeout(() => {
          props.closeModal();
          props.logoutUser();
        }, 1500);
      } else if (response.message === "Please use the different password!") {
        setPopupTxt("Please use different password!");
        setLshow(true);
      }
    }

  }, [props.user.updatePassword]);

  function handleSubmit(event) {
    event.preventDefault();

    const data = {
      id: userid,
      current_password: password_current,
      password: password_new,
    };
    props.updatePassword(data);
  }

  return (
    <>
      <PopUp
        text={popupTxt}
        show={lshow}
        closeModal={() => setLshow(false)}
      />
      <Modal
        show={props.show}
        onHide={props.closeModal}
        dialogClassName="modal-md-changepassword md cp-modal"
        contentClassName="md"
        centered
      >
        <form onSubmit={handleSubmit}>

          {/* ── Header ── */}
          <div className="cp-header">
            <ModalCloseButton onClick={props.closeModal} />
            <div className="cp-icon-ring">
              <FiLock size={26} color="#e01e26" />
            </div>
            <h5 className="cp-title">Change Password</h5>
          </div>

          {/* ── Body ── */}
          <div className="cp-body">

            {/* Current password */}
            <div className="cp-field">
              <label className="cp-label">Current Password</label>
              <div className="cp-input-wrap">
                <FiLock className="cp-input-icon" />
                <input
                  type={showCurrent ? "text" : "password"}
                  className="cp-input"
                  minLength="7"
                  placeholder="Enter current password"
                  {...register("CurrentPassword")}
                  required
                  autoComplete="off"
                  onChange={(e) => setCurrPassword(e.target.value)}
                />
                <button type="button" className="cp-eye-btn" onClick={() => setShowCurrent(!showCurrent)}>
                  {showCurrent ? <IoEye size={20} /> : <IoEyeOff size={20} />}
                </button>
              </div>
            </div>

            {/* New password */}
            <div className="cp-field">
              <label className="cp-label">New Password</label>
              <div className="cp-input-wrap">
                <FiLock className="cp-input-icon" />
                <input
                  type={showNew ? "text" : "password"}
                  className="cp-input"
                  minLength="7"
                  placeholder="Enter new password"
                  {...register("NewPassword")}
                  required
                  autoComplete="off"
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <button type="button" className="cp-eye-btn" onClick={() => setShowNew(!showNew)}>
                  {showNew ? <IoEye size={20} /> : <IoEyeOff size={20} />}
                </button>
              </div>
            </div>

            {/* Confirm password */}
            <div className="cp-field">
              <label className="cp-label">Confirm Password</label>
              <div className="cp-input-wrap">
                <FiLock className="cp-input-icon" />
                <input
                  type={showConfirm ? "text" : "password"}
                  className="cp-input"
                  minLength="7"
                  placeholder="Confirm new password"
                  {...register("ConfirmPassword")}
                  required
                  autoComplete="off"
                  onChange={(e) => setCfmPassword(e.target.value)}
                />
                <button type="button" className="cp-eye-btn" onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? <IoEye size={20} /> : <IoEyeOff size={20} />}
                </button>
              </div>
            </div>

          </div>

          {/* ── Footer ── */}
          <div className="cp-footer">
            <button
              type="submit"
              className="cp-submit-btn"
              ref={buttonElement}
              disabled
            >
              Submit
            </button>
            <p className="cp-powered">Powered by Warely</p>
          </div>

        </form>
      </Modal>
    </>
  )
}

ChangePassword.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user
})

export default withTranslation()(
  connect(mapStateToProps, {
    updatePassword,
    logoutUser
  })(ChangePassword)
);